<template>
  <el-dialog :visible="show" top="5vh" width="1240px"  class="e-fence-dlg" destroy-on-close
    :close-on-click-modal="false" @open="fn_dlg_open" @opened="fn_dlg_opened" @closed="fn_dlg_closed"
    @close="fn_dlg_close">
    <div id="mapContainer">
    </div>
    <div class="drawBtns">
      <input type="text" placeholder="请输入围栏名称" class="input" v-model="name" @input="fn_shape_change"/>
      <el-button type="primary" round @click="clearAll">清空</el-button>
      <el-button type="primary" round @click="circleClick">{{ isCircle ? "圆形" : "绘制中" }}</el-button>
      <el-button type="primary" round @click="polygonClick">{{ isPolygon ? "多边形" : "绘制中" }}</el-button>
      <el-button type="primary" round @click="savepath">{{ edit ? "编辑" : "保存" }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      center: [117.738375, 38.972044], // 地图中心点
      zoom: 14,
      map: undefined,
      //当前的绘制图层
      currentOverlay: undefined,
      //控制绘制圆形的变量
      isCircle: true,
      //控制绘制多变型的变量
      isPolygon: true,
      activeEditor: undefined,
      editorOptions: undefined,
      lineArr: [],
      name: '',
      shape: '',
      // info: this.$route.query.info || {},
      polygon: null,
      circle: null,
      edit: false,
      longitudeLatitude:''
    };
  },
  computed: {
    ...mapGetters(['usergt'])
  },
  watch: {
    show(val){
      if(val){
        console.log("this.info", this.info);
        if (this.info && this.info.id) {
          this.edit = true
          this.name = this.info.electronicFenceName
          this.shape = this.info.shape
          this.longitudeLatitude=this.info.longitudeLatitude
          setTimeout(() => {
            this.renderFences()
          }, 1000)
        }
      }
    }
  },
  // mounted() {
  //   console.log("this.$route.query", this.info);
    

  // },
  methods: {
    fn_shape_change(){
      this.edit=false
    },
    fn_dlg_open() {
      // if (this.info && this.info.id) {
      //     this.edit = true
      //     this.name = this.info.electronicFenceName
      //     this.shape = this.info.shape
      //     setTimeout(() => {
      //       this.renderFences()
      //     }, 1000)
      //   }
    },
    fn_dlg_opened() {
      // this.$refs.formRef.clearValidate()
      this.initMap()
    },
    fn_dlg_close() {
      this.lineArr = []
      this.shape = ''
      this.name = ''
      this.$emit('close')
    },
    fn_dlg_closed() {
      this.AMap = null
      this.map = null
      this.lineArr = []
      this.shape = ''
      this.name = ''
      this.edit=false
      if (this.polygon) {
        if (this.map) {
          this.map.remove(this.polygon)
          this.map.clearMap()
        }
        this.polygon = null
      }
      // this.$cb = null
    },
    async savepath() {
      console.log("this.lineArr", this.lineArr);
      if (this.edit) {
        this.editorpath()
      } else {
        if (this.lineArr.length == 0) {
          return this.$message.error('没有绘制电子围栏')
          // throw '没有绘制电子围栏'
        }
        if (!this.name) {
          return this.$message.error('请填写围栏名称')
        }
        const data = {
          electronicFenceName: this.name,
          longitudeLatitude: this.lineArr.join(';'),
          status: 0,
          shape: this.shape,
          peopleCreate: this.usergt.username,
          fenceMaxCars: '',
          fenceType: 0
        }
        let url;
        if (this.info && this.info.id) {
          url = "/electronicfence/fence/update"
          data.id = this.info.id
        } else {
          url = '/electronicfence/fence/save'
        }
        const res = await this.$http(
          'api1',
          url,
          'post',
          data,
        )
        console.log("res", res)
        if (res.data.code != 0) {
          this.$message.error(res.data.msg)
          throw res
        }
        this.$message.success('操作成功')
        console.log(data);
        if (!this.isCircle) {
          this.circleClick()
        } else if (!this.isPolygon) {
           this.polygonClick()
        }
        this.$emit('success')
        this.$emit('close')
      }
    },
    editorpath() {
      let editor = null
      if (this.info.shape == 'CIRCLE') {
        editor = new AMap.CircleEditor(this.map, this.circle);
      } else {
        editor = new AMap.PolyEditor(this.map, this.polygon);
      }

      // 开启编辑
      editor.open();
      let newDada
      if (this.info.shape == 'CIRCLE') {
        editor.on('adjust', (event) => {
          this.lineArr = []
          this.lineArr[0] = event.target.getCenter().R
          this.lineArr[1] = event.target.getCenter().Q
          this.lineArr[2] = event.target.getRadius()

          console.log("鼠标调整横向和纵向半径：", this.lineArr);
        })
        //鼠标调整图形位置时触发该事件
        editor.on('move', (event) => {
          this.lineArr = []
          this.lineArr[0] = event.target.getCenter().R
          this.lineArr[1] = event.target.getCenter().Q
          this.lineArr[2] = event.target.getRadius()
          console.log("鼠标移动圈选区域：", this.lineArr);
        })
      } else {
        editor.on('adjust', (event) => {
          this.lineArr = []
          newDada = event.target.getPath()
          newDada.forEach(el => { this.lineArr.push([el.lng, el.lat]) })
          // vm.pathData=pathArr
          console.log("鼠标调整横向和纵向半径：", this.lineArr);
        })
        //鼠标调整图形位置时触发该事件
        editor.on('move', (event) => {
          newDada = []
          this.lineArr = event.target.getPath()
          this.lineArr.forEach(el => { newDada.push([el.lng, el.lat]) })
          // vm.pathData=newDada
          console.log("鼠标移动圈选区域：", this.lineArr);
        })
      }
      this.edit = false
    },
    renderFences() {
      if (this.polygon) {
        this.map.remove(this.polygon)
      }
      if (this.circle) {
        this.map.remove(this.circle)
      }
      this.longitudeLatitude = this.shape == 'CIRCLE' ? this.longitudeLatitude.split(';') : this.longitudeLatitude.split(';').map(it => it.split(','))
      if (this.shape == 'CIRCLE') {
        this.circle = new AMap.Circle({ center: this.longitudeLatitude.slice(0, 2), radius: this.longitudeLatitude[2], bubble: true })
        this.map.add(this.circle)
      } else if (this.shape == 'POLYGON') {

        this.polygon = new AMap.Polygon({ path: this.longitudeLatitude, draggable: false, bubble: true })
        this.map.add(this.polygon)
      }
    },
    //地图初始化
    initMap() {
      this.map = new AMap.Map('mapContainer', {
        center: this.center,
        zoom: this.zoom,
        layers: [
          new AMap.TileLayer() // 默认普通地图图层
        ]
      });
      // 初始化 MouseTool
      // 加载 MouseTool 插件
      //MouseTool 是一个鼠标工具插件，用于在地图上绘制图形（如点、线、多边形等），并支持简单的交互。
      AMap.plugin('AMap.MouseTool', () => {
        console.log("MouseTool加载成功");
        //创建一个新的 MouseTool 实例，并将其绑定到地图对象（this.map）。MouseTool 会监听用户在地图上的鼠标操作，支持通过鼠标进行绘制。
        this.drawingManager = new AMap.MouseTool(this.map);  // 初始化 MouseTool
      });
      //editorOptions 是一个配置对象，专门用于控制地图上编辑功能的样式和行为，尤其是与 MouseTool 配合使用时，能够对绘制的图形进行编辑（例如移动标记点、修改多边形节点等）。
      this.editorOptions = {
        editMarkerOptions: {
          // icon: new AMap.Icon({
          //   size: new AMap.Size(16, 16),  // 图标大小
          //   image: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png'
          // }),
          // offset: new AMap.Pixel(-8, -8)  // 图标偏移量
        },
        // 配置可移动的标记点的样式
        moveMarkerOptions: {
          icon: new AMap.Icon({
            size: new AMap.Size(20, 20),
            image: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png'
          }),
          offset: new AMap.Pixel(-10, -10)
        },
        // 配置多边形/线条中间节点的样式
        midMarkerOptions: {
          icon: new AMap.Icon({
            size: new AMap.Size(14, 14),
            image: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png'
          }),
          offset: new AMap.Pixel(-7, -7)
        }
      }
      // 监听绘制完成事件
      // 监听圆形绘制完成事件
      // 测试绑定监听事件
      this.drawingManager.on('draw', (event) => {
        if (this.currentOverlay) {
          this.map.remove(this.currentOverlay)
        }

        this.currentOverlay = event.obj;
        const shape = event.obj;  // 获取绘制的图形对象
        console.log("图形绘制完成", shape instanceof AMap.Circle);
        this.shape = ''
        if (shape instanceof AMap.Circle) {

          this.lineArr = []
          this.lineArr[0] = shape.getCenter().R
          this.lineArr[1] = shape.getCenter().Q
          this.lineArr[2] = shape.getRadius()
          this.shape = 'CIRCLE'
          shape.setOptions({ draggable: true });
          shape.on('dragend', () => {
            // 如果是圆形
            this.lineArr = []
            const center = shape.getCenter();  // 获取圆形中心
            const radius = shape.getRadius();  // 获取圆形半径
            console.log("绘制完成的图形类型: 圆形");
            console.log("圆心经纬度:", center);
            console.log("半径:", radius, "米");
            this.lineArr[0] = center.R
            this.lineArr[1] = center.Q
            this.lineArr[2] = radius
          });
          this.drawingManager.close();
          this.drawCircle();
        } else if (shape instanceof AMap.Polygon) {
          shape.setOptions({ draggable: true });
          this.shape = 'POLYGON'
          shape.on('dragend', () => {
            this.lineArr = []
            const newPath = shape.getPath();  // 获取拖拽后的路径
            console.log('拖拽后的多边形', newPath);
            newPath.map(item => {
              this.lineArr.push([item.R, item.Q])
              return this.lineArr
            })
          });
          // 如果是多边形或矩形（矩形也是多边形的一种）
          this.lineArr = []
          const path = shape.getPath();  // 获取多边形的路径点
          path.map(item => {
            console.log(item.R);
            this.lineArr.push([item.R, item.Q])
            return this.lineArr
          })
          console.log("绘制完成的图形类型: 多边形或矩形");
          console.log("顶点经纬度数组:", path);
          this.drawingManager.close();
          this.drawPolygon();
        }

      });
    },
    //圆形绘制开启
    circleClick() {
      this.drawingManager.close();
      this.isCircle = !this.isCircle;
      if (!this.isPolygon) {
        this.isPolygon = !this.isPolygon;
        this.drawingManager.close();
      }
      if (this.isCircle) {
        this.drawingManager.close();  // 关闭绘图模式
        this.enableEditing();
      } else {
        if (this.currentOverlay) {
          this.clearAllDrawings();
        }
        this.drawCircle();
      }

    },
    //多边形绘制开启
    polygonClick() {
      this.drawingManager.close();
      console.log("drawingManager", this.drawingManager);

      this.isPolygon = !this.isPolygon;
      if (!this.isCircle) {
        this.isCircle = !this.circle;
        this.drawingManager.close();
      }
      if (this.isPolygon) {
        this.drawingManager.close();  // 关闭绘图模式
        this.enableEditing();
      } else {
        if (this.currentOverlay) {
          this.clearAllDrawings();
        }
        this.drawPolygon()
      }
    },
    //开启绘制图形编辑模式
    enableEditing() {
      if (!this.currentOverlay) {
        alert("请先绘制图形！");
        return;
      }
      if (this.currentOverlay instanceof AMap.Circle) {
        if (this.activeEditor) {
          this.activeEditor.close();  // 关闭之前的编辑器
        }
        this.activeEditor = new AMap.CircleEditor(this.map, this.currentOverlay, this.editorOptions);
        console.log("activeEditor", this.activeEditor);
        this.activeEditor.open();

      } else if (this.currentOverlay instanceof AMap.Polygon) {
        if (this.activeEditor) {
          this.activeEditor.close();  // 关闭之前的编辑器
        }
        this.activeEditor = new AMap.PolyEditor(this.map, this.currentOverlay, this.editorOptions);
        console.log("activeEditor", this.activeEditor);
        this.activeEditor.open();

      }

    },
    //清空所有绘制图形
    clearAll() {
      this.lineArr = []
      this.shape = ''
      this.name = ''
      this.clearAllDrawings();
      this.clearCircles();
      this.clearPolygons();
    },
    //用来清空所有的绘制图形
    clearAllDrawings() {
      this.map.clearMap();
    },
    //用来清空绘制图形
    clearCircles() {
      this.map.clearMap();
    },
    //用来清空绘制多边形图形
    clearPolygons() {
      this.map.clearMap();
    },
    //圆形回显
    drawCircle() {
      this.drawingManager.circle({
        strokeColor: 'red',   // 描边颜色
        strokeOpacity: 1,         // 描边透明度
        strokeWeight: 3,          // 描边宽度
        fillColor: 'red',     // 填充颜色
        fillOpacity: 0.5          // 填充透明度
      });
    },
    //多边形回显
    drawPolygon() {
      this.drawingManager.polygon({
        strokeColor: 'red',   // 描边颜色
        strokeOpacity: 1,         // 描边透明度
        strokeWeight: 3,          // 描边宽度
        fillColor: 'red',     // 填充颜色
        fillOpacity: 0.5          // 填充透明度
      });
    }
  },
};
</script>

<style lang="scss">
.amap-marker-label {
  background-color: black;
  /* 设置标签背景颜色 */
  border: 1px solid black;
  /* 设置标签边框 */
  padding: 5px;
  /* 设置标签内边距 */
  border-radius: 5px;
  /* 设置标签圆角 */
  color: white;
  /* 设置标签文字颜色 */
  font-size: 14px;
  /* 设置标签文字大小 */
  width: 130px;
  /* 设置标签宽度 */
  height: 30px;
  /* 设置标签高度 */
  line-height: 20px;
  /* 设置标签行高，使文本垂直居中 */
  text-align: center;
  /* 设置文本居中 */
}
#mapContainer{
  width: 100%;
  height: calc(90vh - 80px);
  margin-top: 20px;
}
.drawBtns {
  position: absolute;
  top: 60px;
  right: 180px;
  z-index: 999;
  width: 450px;
  height: 40px;
  display: flex;
  justify-content: space-between;

  .input {
    width: 200px;
    margin-right: 20px;
    outline: none;
  }
}
</style>